export default "__VITE_ASSET__$byyKYhk__"